export const CONNECT = "CONNECT";
export const UPDATE = "UPDATE";
export const LIVE_AUCTION_NFT = "LIVE_AUCTION_NFT";
export const MY_COLLECTIONS = "MY_COLLECTIONS";
export const SIDEBAR = "SIDEBAR";
export const SEARCH_AUCTIONS = "SEARCH_AUCTIONS";
export const RESET = "RESET";
